import React from "react";
import { string, bool, object, array } from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import { connect } from "react-redux";

import CardImage from "../CardImage";
import { getStoryData } from "../../utils/utils";
import Headline from "../Headline";

import "./focusedCard.m.css";
import StoryMetaData from "../../molecules/StoryMetaData";
import Icon from "../../icons";

const FocusedCard = ({
  story,
  className = "",
  cardWithImageZoom = true,
  showSection = true,
  imageType = "image2x3",
  eager = true,
  aspectRatio = [2, 3],
  updatedFont = false,
  publisherLang = "",
  showTag = false,
  sketchesHost,
}) => {
  const storyData = getStoryData(story);

  if (!storyData.headline || !story.url) {
    return null;
  }

  const section = get(story, ["sections", "0"], null);
  const tag = get(story, ["tags", "0"], null);
  const storyHeadlineStyle = updatedFont ? `${publisherLang}-story-headline` : "";
  const sectionNameStyle = updatedFont ? `${publisherLang}-section-name section-name` : "section-name";

  const getMetaInfo = () => {
    if (showTag && tag) {
      return (
        <Link href={`${sketchesHost}/topic/${tag.slug}`}>
          <div styleName={sectionNameStyle}>{tag.name}</div>
        </Link>
      );
    } else if (showSection && section) {
      return (
        <Link href={section["section-url"]}>
          <div styleName={sectionNameStyle}>{section["display-name"] || section.name}</div>
        </Link>
      );
    } else return null;
  };

  return (
    <div
      aria-label={`${"Read full story: "} ${storyData.headline}`}
      className={`${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""} focused-card`}
    >
      <div styleName="base">
        <Link href={story.url}>
          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={[350]}
            eager={eager}
            showAlternateImage={true}
          />
        </Link>
        {getMetaInfo()}
        <div styleName="text-wrapper">
          <span className="story-type-wrapper">
            {story["story-template"] === "video" && <Icon type="video-whitebg" className="video-whitebg" />}
            {story["story-template"] === "photo" && <Icon type="gallery-whitebg" className="gallery-whitebg" />}
          </span>
          <Link href={story.url}>
            <Headline
              text={storyData.headline}
              headerLevel={2}
              headlineType={21}
              className="headline highlight"
              styleName={storyHeadlineStyle}
            />
          </Link>
          <StoryMetaData story={story} isAuthor={false} updatedFont={updatedFont} publisherLang={publisherLang} />
        </div>
      </div>
    </div>
  );
};

FocusedCard.propTypes = {
  className: string,
  cardWithImageZoom: bool,
  story: object,
  showSection: bool,
  imageType: string,
  eager: bool,
  aspectRatio: array,
  updatedFont: bool,
  publisherLang: string,
  showTag: bool,
  sketchesHost: string,
};

const mapStateToProps = (state) => ({
  sketchesHost: get(state, ["qt", "config", "sketches-host"]),
});

export default connect(mapStateToProps, null)(FocusedCard);
